/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bot: NonNullable<unknown> }} Leveling_Run_Subject_MessagesInputs */



/**
* | output |
* | --- |
* | "{bot}'s level-up messages" |
*
* @param {Leveling_Run_Subject_MessagesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_run_subject_messages = /** @type {((inputs: Leveling_Run_Subject_MessagesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Run_Subject_MessagesInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сообщения ${i?.bot} о повышении уровня`)
	return /** @type {LocalizedString} */ (`${i?.bot}'s level-up messages`)
});